export const ADJUSTMENTS_FETCH = 'ADJUSTMENTS_FETCH';
export const ADJUSTMENTS_IS_FETCING = 'ADJUSTMENTS_IS_FETCING';
export const ADJUSTMENTS_API = 'adjustments';
export const ADJUSTMENT_EDIT = 'ADJUSTMENT_EDIT';
export const ADJUSTMENT_SAVE = 'ADJUSTMENT_SAVE';
export const ADJUSTMENT_FILTER = 'ADJUSTMENT_FILTER';
export const SET_ADJUSTMENT_VIEW_FILTER = 'SET_ADJUSTMENT_VIEW_FILTER';
export const UPDATE_ADJUSTMENT_STATUS = 'UPDATE_ADJUSTMENT_STATUS';



// WEBPACK FOOTER //
// ./src/constants/adjustments.js